import * as React from 'react';

import styles from './Badge.module.scss';

const Badge: React.FC = ({ children }) => {
    return <span className={styles.badge}>{children}</span>;
};

export default Badge;
